const constants = () => {
    return (
        {
            "EXAM": {
                "SEM": "semester",
                "MID1": "mid1",
                "MID2": "mid2",
                "MID3": "mid3"
            },
            "FILE_CATEGORY": {
                "QUESTIONS": "qns",
                "STUDY_MATERIALS": "study_materials",
                "ASSIGNMENTS": "assignments"
            },
            "HELP_VIDEOS": {
                "appadmin": "",
                "admins": "https://www.youtube.com/embed/_FkE0vvw_c0",
                "super_admins": "https://www.youtube.com/embed/fwbCNpeyvYI",
                "cos": "https://www.youtube.com/embed/WIGwb23vhZ4",
                "crs": "",
                "faculties": "https://www.youtube.com/embed/O2I8NRLMZ6o",
                "student": "https://www.youtube.com/embed/U56tDFNT6-o"
            },
            "ROLES": {
                "APP_ADMIN": "appadmin",
                "ADMIN": "admins",
                "SUPER_ADMIN": "super_admins",
                "CO": "cos",
                "CR": "crs",
                "FACULTY": "faculties",
                "STUDENT": "student"
            },
            "ROLE_NAMES": {
                "appadmin": "App Admin",
                "admins": "admin",
                "super_admins": "super admin",
                "cos": "coordinator",
                "crs": "class representative",
                "faculties": "faculty",
                "student": "student"
            },
            "SCOPES": {
                "APP_ADMIN": [
                    "https://www.googleapis.com/auth/userinfo.profile"
                ],
                "ADMIN": [
                    "https://www.googleapis.com/auth/userinfo.profile"
                ],
                "SUPER_ADMIN": [
                    "https://www.googleapis.com/auth/userinfo.profile"
                ],
                "CO": [
                    "https://www.googleapis.com/auth/userinfo.profile",
                    "https://www.googleapis.com/auth/drive.file",
                    "email"
                ],
                "CR": [
                    "https://www.googleapis.com/auth/userinfo.profile",
                    "https://www.googleapis.com/auth/drive.file",
                    "email"
                ],
                "FACULTY": [
                    "https://www.googleapis.com/auth/userinfo.profile",
                    "https://www.googleapis.com/auth/drive.file",
                    "email"
                ],
                "STUDENT": [
                    "https://www.googleapis.com/auth/userinfo.profile"
                ]
            }
        }    );
};

export default constants;
